import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SpaceComponent } from './space.component';

const routes: Routes = [{
  path: ':id',
  component: SpaceComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SpaceRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/space/space-routing.module.ts